import React, { useState, useEffect, useLayoutEffect } from "react";
import styles from "./characters.module.css";

import Tree1 from "../assets/Characters/2x/monkeyboard.png";
import Animalbtn1 from "../assets/Characters/2x/Asset 245@2x.webp";
import tigru from "../assets/Characterpopup/Asset 125@2x.png"
import Animalbtn2 from "../assets/Characters/2x/Asset 240@2x.webp";
import puppydoo from "../assets/Characterpopup/Asset 126@2x.png"
import Animalbtn3 from "../assets/Characters/2x/Asset 247@2x.webp";
import eleboo from "../assets/Characterpopup/Asset 107@2x.png"
import Animalbtn4 from "../assets/Characters/2x/Asset 244@2x.webp";
import turtloo from "../assets/Characterpopup/Asset 122@2x.png"
import wall from "../assets/Characters/2x/walll.webp";
import river from "../assets/Characters/2x/river.webp"
import Lion from "../assets/Characters/2x/Lion.webp"
import Frog from "../assets/Characters/2x/frogf.webp"
import Boll from "../assets/Characters/2x/Boll.webp"
import meeting from "../assets/Characters/2x/meeting.webp"
import board from "../assets/Characters/2x/Asset 297@2x.png"
import Elephant from "../assets/Characters/2x/Asset 296@2x.png"
import Party from "../assets/Characters/2x/partyy.webp"
import fox from "../assets/Characters/2x/foxx.webp"
import Deer from "../assets/Characters/2x/Deer.webp"
import Treewithland from "../assets/Characters/2x/treewithlandd.webp"
import Riveranimal1 from "../assets/Characters/2x/Asset 257@2x.webp"
import Riveranimal2 from "../assets/Characters/2x/Asset 234@2x.webp"
import Fish1 from "../assets/Characters/2x/Asset 256@2x.webp"
import Fish2 from "../assets/Characters/2x/Asset 255@2x.webp"
import Fish3 from "../assets/Characters/2x/Asset 254@2x.webp"
import monkeybtn1 from "../assets/Characters/2x/Asset 230@2x.webp"
import monkeybtn2 from "../assets/Characters/2x/Asset 231@2x.webp"
import monkeyboard from "../assets/Characterpopup/Asset 105@2x.png"
import Birdonboard from "../assets/Characters/2x/Asset 265@2x.webp"
import Birdbutton from "../assets/Characters/2x/Asset 220@2x.webp"
import spoo from "../assets/Characterpopup/Asset 123@2x.png"
import Elephantbutton from "../assets/Characters/2x/Asset 248@2x.webp"
import elephiphi from "../assets/Characterpopup/Asset 110@2x.png"
import Birdonwall from "../assets/Characters/2x/Asset 223@2x.webp"
import broop from "../assets/Characterpopup/Asset 116@2x.png"
import Wallanimalbtn1 from "../assets/Characters/2x/Asset 229@2x.webp"
import jackie from "../assets/Characterpopup/Asset 104@2x.png"
import Wallanimalbtn2 from "../assets/Characters/2x/Asset 242@2x.webp"
import wolfie from "../assets/Characterpopup/Asset 120@2x.png"
import treeanimalbtn1 from "../assets/Characters/2x/Asset 243@2x.webp"
import moocow from "../assets/Characterpopup/Asset 119@2x.png"
import treeanimalbtn2 from "../assets/Characters/2x/Asset 224@2x.webp"
import kaoloo from "../assets/Characterpopup/Asset 115@2x.png"
import Frogbtn from "../assets/Characters/2x/Asset 241@2x.webp"
import turtlee from "../assets/Characterpopup/Asset 113@2x.png"
import Foxbtn from "../assets/Characters/2x/Asset 240@2x.webp"
import dogu from "../assets/Characterpopup/Asset 118@2x.png"
import Deerbtn from "../assets/Characters/2x/Asset 239@2x.webp"
import loopy from "../assets/Characterpopup/Asset 111@2x.png"
import lionbtn from "../assets/Characters/2x/Asset 238@2x.webp"
import lionus from "../assets/Characterpopup/Asset 112@2x.png"
import Riverani1btn from "../assets/Characters/2x/Asset 237@2x.webp"
import crocodo from "../assets/Characterpopup/Asset 102@2x.png"
import Riverani2btn from "../assets/Characters/2x/Asset 235@2x.webp"
import hippopopo from "../assets/Characterpopup/Asset 117@2x.png"
import Fishbtn from "../assets/Characters/2x/Asset 225@2x.webp"
import fishboard from "../assets/Characterpopup/Asset 106@2x.png"
import Partyani1 from "../assets/Characters/2x/Asset 226@2x.webp"
import rababy from "../assets/Characterpopup/Asset 124@2x.png"
import Partyani2 from "../assets/Characters/2x/Asset 227@2x.webp"
import rabbitu from "../assets/Characterpopup/Asset 121@2x.png"
import Partyani3 from "../assets/Characters/2x/Asset 236@2x.webp"
import sheepoo from "../assets/Characterpopup/Asset 114@2x.png"
import Partyani4 from "../assets/Characters/2x/Asset 227@2x.webp"
import motherrabbit from "../assets/Characterpopup/Asset 108@2x.png"
import Stone from "../assets/Characters/2x/Asset 222@2x.webp"
import QueenBird from "../assets/Characters/2x/Asset 221@2x.webp"
import querow from "../assets/Characterpopup/Asset 109@2x.png"
import { Helmet } from "react-helmet-async";

// Character data with text content
const characterData = {
  [monkeyboard]: {
    name: "Monko",
    title: "Hello! We are Gorilli and Gorillu",
    description: [
      "We are dutiful",
      "We are responsible",
      "We work hard"
    ],
    className: "monkoText",
    imageWidth: "900px",  // ← Yahan se image width control karo
    imageHeight: "auto",   // ← Yahan se image height control karo




  },
  [elephiphi]: {
    name: "Elephiphi",
    title: "Hello! I am Mr. Elephiphi",
    description: [
      "I am gentle",
      "I am loving",
      "I am smart"
    ],
    className: "elephiphiText",
    imageWidth: "600px",
    imageHeight: "auto"
  },
  [tigru]: {
    name: "Tigru",
    title: "Hello ! I am Tigru",
    description: [
      "I am passionate",
      "I am competitive",
      "I help everyone"
    ],
    className: "tigruText",
    imageWidth: "300px",
    imageHeight: "auto"
  },
  [puppydoo]: {
    name: "Puppydoo",
    title: "Hello ! I am Puppydoo",
    description: [
      "I am curious",
      "I am silly",
      "I learn fast"
    ],
    className: "puppydooText",
    imageWidth: "380px",
    imageHeight: "auto"
  },
  [eleboo]: {
    name: "Eleboo",
    title: "Hello ! I am Eleboo",
    description: [
      "I am smart",
      "I am helpful",
      "I am caring"
    ],
    className: "elebooText",
    imageWidth: "390px",
    imageHeight: "auto"
  },
  [turtloo]: {
    name: "Turtloo",
    title: "Hello ! I am Turtloo",
    description: [
      "I am gentle",
      "I am kind",
      "I am friendly"
    ],
    className: "turtlooText",
    imageWidth: "380px",
    imageHeight: "auto"
  },
  [spoo]: {
    name: "Spoo",
    title: "Hello! I am Spoo",
    description: [
      "I am quirky",
      "I am honest",
      "I am careful"
    ],
    className: "spooText",
    imageWidth: "380px",
    imageHeight: "auto"
  },
  [broop]: {
    name: "Broop",
    title: "Hello! I am Broop",
    description: [
      "I am honest",
      "I am smart",
      "I am brave"
    ],
    className: "broopText",
    imageWidth: "380px",
    imageHeight: "auto"
  },
  [jackie]: {
    name: "Jackie",
    title: "Hello! I am Jackie",
    description: [
      "I am cheerful",
      "I am courageous",
      "I am hopeful"
    ],
    className: "jackieText",
    imageWidth: "650px",
    imageHeight: "auto",
    mobileImageWidth: "450px",
    mobileImageHeight: "500px"
  },
  [wolfie]: {
    name: "Wolfie",
    title: "Hello! I am Wolfie",
    description: [
      "I am creative",
      "I am smart",
      "I am joyful"
    ],
    className: "wolfieText",
    imageWidth: "400px",
    imageHeight: "auto",
    mobileImageWidth: "450px",
    mobileImageHeight: "500px"
  },
  [kaoloo]: {
    name: "Koaloo",
    title: "Hello! I am Koaloo",
    description: [
      "I work hard",
      "I am helpful",
      "I am disciplined"
    ],
    className: "kaolooText",
    imageWidth: "500px",
    imageHeight: "auto"
  },
  [moocow]: {
    name: "Moocow",
    title: "Hello! I am Moocow",
    description: [
      "I am wise ",
      "I am special",
      "I am gentle"
    ],
    className: "moocowText",
    imageWidth: "450px",
    imageHeight: "auto"
  },
  [turtlee]: {
    name: "Turtlee",
    title: "Hello! I am Turtlee",
    description: [
      "I am peaceful ",
      "I am wise",
      "I am supportive"
    ],
    className: "turtleeText",
    imageWidth: "400px",
    imageHeight: "auto"
  },
  [dogu]: {
    name: "Dogu",
    title: "Hello! I am Dogu",
    description: [
      "I am loving",
      "I am gentle",
      "I am friendly"
    ],
    className: "doguText",
    imageWidth: "400px",
    imageHeight: "auto"
  },
  [loopy]: {
    name: "Loopy",
    title: "Hello! I am Loopy",
    description: [
      "I am respectful",
      "I am polite",
      "I am brave"
    ],
    className: "loopyText",
    imageWidth: "400px",
    imageHeight: "auto"
  },
  [lionus]: {
    name: "Lionus",
    title: "Hello! I am Lionus ",
    description: [
      "I am special",
      "I am confident",
      "I am brave"
    ],
    className: "lionusText",
    imageWidth: "400px",
    imageHeight: "auto"
  },
  [crocodo]: {
    name: "Crocodo",
    title: "Hello! I am Crocodo",
    description: [
      "I am inventive",
      "I am curious",
      "I am dutiful"
    ],
    className: "crocodoText",
    imageWidth: "450px",
    imageHeight: "auto"
  },
  [hippopopo]: {
    name: "Hippopopo",
    title: "Hello! I am Hippopopo ",
    description: [
      "I am compassionate",
      "I am learning",
      "I am cheerful"
    ],
    className: "hippopopoText",
    imageWidth: "450px",
    imageHeight: "auto"
  },
  [fishboard]: {
    name: "Fishy Friends",
    title: "Hello! We are Tunu,Tono,Tuni",
    description: [
      "We are creative",
      "We are a team",
      "We are playful"
    ],
    className: "fishboardText",
    imageWidth: "880px",
    imageHeight: "auto",

  },
  [rababy]: {
    name: "Rababy",
    title: "Hello! I am Rababy",
    description: [
      "I am learning",
      "I am gentle",
      "I am joyful"
    ],
    className: "rababyText",
    imageWidth: "350px",
    imageHeight: "auto",
    mobileImageWidth: "450px",
    mobileImageHeight: "430px"
  },
  [rabbitu]: {
    name: "Rabbitu",
    title: "Hello! I am Rabbitu",
    description: [
      "I am honest",
      "I am friendly",
      "I am fair"
    ],
    className: "rabbituText",
    imageWidth: "400px",
    imageHeight: "auto",
    mobileImageWidth: "450px",
    mobileImageHeight: "500px"
  },
  [sheepoo]: {
    name: "Sheepoo",
    title: "Hello! I am Sheepoo",
    description: [
      "I am noble",
      "I am unique",
      "I work hard"
    ],
    className: "sheepooText",
    imageWidth: "500px",
    imageHeight: "auto"
  },
  [motherrabbit]: {
    name: "Mother Rabbit",
    title: "Hello! I am Mother Rabbit",
    description: [
      "I am loving",
      "I am motherly",
      "I am generous"
    ],
    className: "motherrabbitText",
    imageWidth: "670px",
    imageHeight: "auto",
    mobileImageWidth: "550px",
    mobileImageHeight: "600px"

  },
  [querow]: {
    name: "Querow",
    title: "Hello! I am Querow",
    description: [
      "I am peaceful",
      "I am strong",
      "I am supportive"
    ],
    className: "querowText",
    imageWidth: "380px",
    imageHeight: "auto",

  }
};

function Characters() {
  const [boardOpen, setBoardOpen] = useState(false);
  const [boardImg, setBoardImg] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  // Check if mobile device
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);


  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const openBoard = (img) => { setBoardImg(img); setBoardOpen(true); };
  const closeBoard = () => { setBoardOpen(false); setBoardImg(null); };

  useEffect(() => {
    if (!boardOpen) return;
    const onKey = (e) => { if (e.key === 'Escape') closeBoard(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [boardOpen]);

  // Check if image should be large
  const largeImages = [monkeyboard, elephiphi, jackie, wolfie, kaoloo, moocow, turtlee, dogu, loopy, lionus, rabbitu, sheepoo, motherrabbit, crocodo, hippopopo, fishboard];
  const isLargeImage = boardImg && largeImages.includes(boardImg);
  const currentCharacter = boardImg ? characterData[boardImg] : null;

  return (
    <>
     <Helmet>
  <title>
    Good Habits for Kids | Fun Learning Characters - Jungle Morals
  </title>

  <meta
    name="description"
    content="Meet Elephiphi, Liona, and friends who help kids learn kindness, sharing, honesty, and healthy daily habits through fun stories, songs, and educational videos."
  />

  <meta name="robots" content="index, follow" />

  <link
    rel="canonical"
    href="https://www.junglemorals.com/characters"
  />

  <meta
  property="og:title"
  content="Good Habits for Kids | Fun Learning Characters - Jungle Morals"
/>

<meta
  property="og:description"
  content="Meet Elephiphi, Liona, and friends who help kids learn kindness, sharing, honesty, and healthy daily habits through fun stories, songs, and educational videos."
/>

<meta
  property="og:url"
  content="https://www.junglemorals.com/characters"
/>

<meta
  property="og:type"
  content="website"
/>

<meta
  property="og:image"
  content="https://www.junglemorals.com/static/media/characters-banner.webp"
/>

<meta
  name="twitter:card"
  content="summary_large_image"
/>

<meta
  name="twitter:title"
  content="Good Habits for Kids | Fun Learning Characters - Jungle Morals"
/>

<meta
  name="twitter:description"
  content="Meet Elephiphi, Liona, and friends who help kids learn kindness, sharing, honesty, and healthy daily habits through fun stories, songs, and educational videos."
/>

<meta
  name="twitter:image"
  content="https://www.junglemorals.com/static/media/characters-banner.webp"
/>

  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Organization",
          "@id": "https://www.junglemorals.com/#organization",
          name: "Jungle Morals",
          url: "https://www.junglemorals.com/",
          logo: {
            "@type": "ImageObject",
            url: "https://www.junglemorals.com/static/media/logo.webp"
          }
        },
        {
          "@type": "WebSite",
          "@id": "https://www.junglemorals.com/#website",
          url: "https://www.junglemorals.com/",
          name: "Jungle Morals",
          publisher: {
            "@id": "https://www.junglemorals.com/#organization"
          }
        },
        {
          "@type": "WebPage",
          "@id": "https://www.junglemorals.com/characters#webpage",
          url: "https://www.junglemorals.com/characters",
          name: "Kids Learning Characters - Jungle Morals",
          description:
            "Meet fun Jungle Morals characters that help kids learn kindness, honesty, sharing, and good habits through stories and songs.",
          isPartOf: {
            "@id": "https://www.junglemorals.com/#website"
          },
          about: {
            "@id": "https://www.junglemorals.com/#organization"
          },
          primaryImageOfPage: {
            "@type": "ImageObject",
            url: "https://www.junglemorals.com/static/media/characters-banner.webp"
          }
        },
        {
          "@type": "BreadcrumbList",
          "@id": "https://www.junglemorals.com/characters#breadcrumb",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Home",
              item: "https://www.junglemorals.com/"
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "Characters",
              item: "https://www.junglemorals.com/characters"
            }
          ]
        },
        {
          "@type": "ItemList",
          "name": "Jungle Morals Characters",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "item": {
                "@type": "Person",
                "name": "Elephiphi"
              }
            },
            {
              "@type": "ListItem",
              "position": 2,
              "item": {
                "@type": "Person",
                "name": "Liona"
              }
            }
          ]
        }
      ]
    })}
  </script>
</Helmet>
      <div className={styles.characters}>
        <div className={styles.sceneWrapper}>
          {/* Trees */}
          <div className={styles.trees}>
            <div className={`font-adventuring ${styles.headingtext}`}>
              <h1 className={styles.sayhi}>Say Hi to our Cuties</h1>
              <h1 className={styles.pawsclicktext}>Click the Paws you can Find!</h1>
            </div>
            <img src={Tree1} className={styles.tree1} alt="Tree Left" />
            <div className={styles.monkeybutton}>
              <img
                src={monkeybtn1}
                alt="monkey button 1"
                role="button"
                tabIndex={0}
                onClick={() => openBoard(monkeyboard)}
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') openBoard(monkeyboard); }}
              />
              <img
                src={monkeybtn2}
                alt="monkey button 2"
                role="button"
                tabIndex={0}
                onClick={() => openBoard(monkeyboard)}
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') openBoard(monkeyboard); }}
              />
            </div>
          </div>

          {/* Center Board */}
          <div className={styles.Board}>
            <img src={board} className={styles.Boardimg} alt="Board" />
            <img src={Elephant} className={styles.Elephant} alt="Board" />
            <div className={styles.Boardtxt}>
              <h2 className={`font-chalkduster ${styles.boardheading}`}>THINGS WE LEARNT TODAY</h2>
              <ol className={`font-chalkduster `}>
                <li className={styles.boardlist}>Only take what you need and not more. </li>
                <li className={styles.boardlist}>Save water and do not waste food.</li>
                <li className={styles.boardlist}>Be thankful for what you have and help people in need.</li>
              </ol>
            </div>

            <div className={styles.Birdonboard}>
              <img src={Birdonboard} alt="Board" />
              <div className={styles.Boardbtn}>
                <img
                  src={Birdbutton}
                  alt="birdbutton"
                  role="button"
                  tabIndex={0}
                  onClick={() => openBoard(spoo)}
                  onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') openBoard(spoo) }}
                />
              </div>
              <div className={styles.Elephantbtn}>
                <img
                  src={Elephantbutton}
                  alt="elephantbtn"
                  role="button"
                  tabIndex={0}
                  onClick={() => openBoard(elephiphi)}
                  onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') openBoard(elephiphi) }}
                />
              </div>
            </div>
          </div>

          {/* Animals */}
          <div className={styles.animals}>
            <img src={meeting} alt="Cartoon animal friends-elephant, tiger, turtle, and dog-sitting together happily." />
            <div className={styles.meetingbtn}>
              <div className={styles.animalbtn1}>
                <img
                  src={Animalbtn1}
                  alt="tigrubtn"
                  role="button"
                  tabIndex={0}
                  onClick={() => openBoard(tigru)}
                  onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') openBoard(tigru) }}
                />
              </div>
              <div className={styles.animalbtn2}>
                <img
                  src={Animalbtn2}
                  alt="puppydoobtn"
                  role="button"
                  tabIndex={0}
                  onClick={() => openBoard(puppydoo)}
                  onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') openBoard(puppydoo) }}
                />
              </div>
              <div className={styles.animalbtn3}>
                <img
                  src={Animalbtn3}
                  alt="eleboobtn"
                  role="button"
                  tabIndex={0}
                  onClick={() => openBoard(eleboo)}
                  onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') openBoard(eleboo) }}
                />
              </div>
              <div className={styles.animalbtn4}>
                <img
                  src={Animalbtn4}
                  alt="turtloobtn"
                  role="button"
                  tabIndex={0}
                  onClick={() => openBoard(turtloo)}
                  onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') openBoard(turtloo) }}
                />
              </div>
            </div>
          </div>

          <div className={styles.wall_tree}>
            <div className={styles.wall}>
              <img src={wall} alt="Wall" />
              <div className={styles.Birdonwall}>
                <img src={Birdonwall} alt="Board" />
                <div className={styles.wallbtn}>
                  <img
                    src={Birdbutton}
                    alt="broopbtn"
                    role="button"
                    tabIndex={0}
                    onClick={() => openBoard(broop)}
                    onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') openBoard(broop) }}
                  />
                </div>
                <div className={styles.Wallanimalbtn1}>
                  <img
                    src={Wallanimalbtn1}
                    alt="jackiebtn"
                    role="button"
                    tabIndex={0}
                    onClick={() => openBoard(jackie)}
                    onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') openBoard(jackie) }}
                  />
                </div>
                <div className={styles.Wallanimalbtn2}>
                  <img
                    src={Wallanimalbtn2}
                    alt="wolfiebtn"
                    role="button"
                    tabIndex={0}
                    onClick={() => openBoard(wolfie)}
                    onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') openBoard(wolfie) }}
                  />
                </div>
              </div>
            </div>

            <div className={styles.treeBlock}>
              <div className={styles.treewithanimal}>
                <img src={Treewithland} alt="Animal on Tree" />
                <div className={styles.treeanimalbtn}>
                  <div className={styles.treeanimalbtn2}>
                    <img
                      src={treeanimalbtn2}
                      alt="koaloobtn"
                      role="button"
                      tabIndex={0}
                      onClick={() => openBoard(kaoloo)}
                      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') openBoard(kaoloo) }}
                    />
                  </div>
                  <div className={styles.treeanimalbtn1}>
                    <img
                      src={treeanimalbtn1}
                      alt="moocowbtn"
                      role="button"
                      tabIndex={0}
                      onClick={() => openBoard(moocow)}
                      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') openBoard(moocow) }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <section className={styles.riverSection}>
            <div className={styles.riverdiv}>
              <div className={styles.right}>
                <div className={styles.boll}>
                  <img src={Boll} alt="Orange and white beach ball" />
                </div>
                <div className={styles.frog}>
                  <img src={Frog} alt="Cartoon turtle meditating calmly" />
                  <div className={styles.frogbtn}>
                    <img
                      src={Frogbtn}
                      alt="Logo"
                      role="button"
                      tabIndex={0}
                      onClick={() => openBoard(turtlee)}
                      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') openBoard(turtlee) }}
                    />
                  </div>
                </div>
                <div className={styles.fox}>
                  <img src={fox} alt="Cartoon dog smiling and gesturing" />
                  <div className={styles.foxbtn}>
                    <img
                      src={Foxbtn}
                      alt="dogubtn"
                      role="button"
                      tabIndex={0}
                      onClick={() => openBoard(dogu)}
                      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') openBoard(dogu) }}
                    />
                  </div>
                </div>
                <div className={styles.Deer}>
                  <img src={Deer} alt="Cartoon deer jumping happily" />
                  <div className={styles.Deerbtn}>
                    <img
                      src={Deerbtn}
                      alt="loppybtn"
                      role="button"
                      tabIndex={0}
                      onClick={() => openBoard(loopy)}
                      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') openBoard(loopy) }}
                    />
                  </div>
                </div>
                <div className={styles.Birdonstone}>
                  <img src={Stone} alt="" />
                  <div className={styles.QueenBird}>
                    <img src={QueenBird} alt="Cartoon bird with crown and staff" />
                  </div>
                  <div className={styles.QueenBirdBtn}>
                    <img
                      src={Birdbutton}
                      alt="querowbtn"
                      role="button"
                      tabIndex={0}
                      onClick={() => openBoard(querow)}
                      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') openBoard(querow) }}
                    />
                  </div>
                </div>
                <div className={styles.lion}>
                  <img src={Lion} alt="Cartoon lion peeking from bushes" />
                  <div className={styles.Lionbtn}>
                    <img
                      src={lionbtn}
                      alt="lionusbtn"
                      role="button"
                      tabIndex={0}
                      onClick={() => openBoard(lionus)}
                      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') openBoard(lionus) }}
                    />
                  </div>
                </div>
                <div className={styles.party}>
                  <img src={Party} alt="Cartoon rabbits and a sheep cooking together" />
                  <div className={styles.partyani1}>
                    <img
                      src={Partyani1}
                      alt="rababtbtn"
                      role="button"
                      tabIndex={0}
                      onClick={() => openBoard(rababy)}
                      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') openBoard(rababy) }}
                    />
                  </div>
                  <div className={styles.partyani2}>
                    <img
                      src={Partyani2}
                      alt="rabitubtn"
                      role="button"
                      tabIndex={0}
                      onClick={() => openBoard(rabbitu)}
                      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') openBoard(rabbitu) }}
                    />
                  </div>
                  <div className={styles.partyani3}>
                    <img
                      src={Partyani3}
                      alt="sheepoobtn"
                      role="button"
                      tabIndex={0}
                      onClick={() => openBoard(sheepoo)}
                      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') openBoard(sheepoo) }}
                    />
                  </div>
                  <div className={styles.partyani4}>
                    <img
                      src={Partyani4}
                      alt="motherrabitbtn"
                      role="button"
                      tabIndex={0}
                      onClick={() => openBoard(motherrabbit)}
                      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') openBoard(motherrabbit) }}
                    />
                  </div>
                </div>
              </div>

              <div className={styles.leftWrapper}>
                <div className={styles.riverContainer}>
                  <img src={river} alt="River" />
                </div>
                <div className={styles.riverObjects}>
                  <div className={styles.riveranimal1}>
                    <img src={Riveranimal1} alt="Riveranimal1" />
                    <div className={styles.riveranibtn1}>
                      <img
                        src={Riverani1btn}
                        alt="crocodobtn"
                        role="button"
                        tabIndex={0}
                        onClick={() => openBoard(crocodo)}
                        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') openBoard(crocodo) }}
                      />
                    </div>
                  </div>
                  <div className={styles.riveranimal2}>
                    <img src={Riveranimal2} alt="Riveranimal2" />
                    <div className={styles.riveranimal2btn}>
                      <img
                        src={Riverani2btn}
                        alt="hoppopopobtn"
                        role="button"
                        tabIndex={0}
                        onClick={() => openBoard(hippopopo)}
                        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') openBoard(hippopopo) }}
                      />
                    </div>
                  </div>
                  <div className={styles.fish1}>
                    <img src={Fish1} alt="" />
                  </div>
                  <div className={styles.fish2}>
                    <img src={Fish2} alt="" />
                    <div className={styles.fishbtn}>
                      <img
                        src={Fishbtn}
                        alt="fishboardbtn"
                        role="button"
                        tabIndex={0}
                        onClick={() => openBoard(fishboard)}
                        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') openBoard(fishboard) }}
                      />
                    </div>
                  </div>
                  <div className={styles.fish3}>
                    <img src={Fish3} alt="" />
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      {/* Modal with Text Overlay */}
      {boardOpen && (
        <>
          <div className={styles.backdropLayer} />
          <div className={styles.centerModal} role="dialog" aria-modal="true" onClick={(e) => e.stopPropagation()}>
            {/* <button 
                className={styles.closeButton}
                onClick={closeBoard}
                aria-label="Close modal"
              >
               ×
              </button> */}


            <button
              className={styles.closeButton}
              onClick={closeBoard}
              aria-label="Close modal"
            >
              <svg
                width="36"
                height="36"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="3"
                strokeLinecap="round"
              >
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
            <div className={styles.modalContent}>
              {/* Close Button */}


              {boardImg && currentCharacter && (
                <>
                  <img
                    src={boardImg}
                    alt="Character Board"
                    style={{
                      // Mobile ho to mobile size, nahi to desktop size
                      width: isMobile ? currentCharacter.mobileImageWidth : currentCharacter.imageWidth,
                      height: isMobile ? currentCharacter.mobileImageHeight : currentCharacter.imageHeight,
                      maxWidth: '90vw',
                      maxHeight: '90vh',
                      objectFit: 'contain'
                    }}
                  />
                  <div className={`${styles.modalTextOverlay} ${styles[currentCharacter.className]}`}>
                    <h2 className="font-adventuring">{currentCharacter.title}</h2>
                    <div className="font-adventuring">
                      {Array.isArray(currentCharacter.description) ? (
                        currentCharacter.description.map((line, idx) => (
                          <p key={idx}>{line}</p>
                        ))
                      ) : (
                        <p>{currentCharacter.description}</p>
                      )}
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </>
      )}
    </>
  );

}

export default Characters;